<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <div>
                    <h5>Asigne los talleres que serán evaluadas por los de alumnos</h5>
                                <!-- datos -->
                                    <div >
                                        <dx-data-grid
                                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                                        id="tabla"
                                        [columnAutoWidth]="true"
                                        [dataSource]="DataTaller"
                                        [noDataText]="'Sin Datos'"
                                        [(selectedRowKeys)]="selectedRows"
                                        [showColumnHeaders]="true"
                                        (onEditorPrepared)="onEditorPreparing($event)"
                                        (onSelectionChanged)="onSelectionChanged($event)"
                                        >
                                        <dxo-paging [pageSize]="100"></dxo-paging>
                                        <dxo-search-panel
                                            [visible]="true"
                                            [width]="240"
                                            placeholder="{{'Buscar' | translate}}">
                                        </dxo-search-panel>

                                        <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>
                                        <dxo-selection mode="multiple" [showCheckBoxesMode]="'always'" *ngIf="identificador == 1"></dxo-selection>
                                        <dxi-column [allowEditing]="!visualizador" *ngIf="visualizador"
                                        alignment="center"
                                        dataField="activo"
                                        caption="Selección"
                                        dataType="boolean"
                                    >
                                    </dxi-column>
                                        <dxi-column
                                            dataField="taller" [allowEditing]="false"
                                            caption="Taller">
                                        </dxi-column>
                                        <dxi-column
                                            dataField="nombre" [allowEditing]="false"
                                            caption="Profesor">
                                        </dxi-column>
                                        <dxi-column
                                        [allowExporting]="false" [allowEditing]="false"
                                        caption="Seleccionar puesto"
                                        [width]="300"
                                        cellTemplate="cellAccionespuesto"
                                        alignment="center">
                                    </dxi-column>
                                    <div *dxTemplate="let cellM of 'cellAccionespuesto'">
                                      <dx-select-box [items]="cellM.data.listapuestos" displayExpr="nombre"  [(value)]="cellM.data.puestoid" valueExpr="puestoid" (onValueChanged)="onPuestoSeleccionado(cellM.data)">
                                        <div *dxTemplate="let data of 'dropDownButton'">
                                          <div class="dx-dropdowneditor-icon"></div>
                                        </div>

                                        <div *dxTemplate="let data of 'item'" class="custom-item">
                                          <div class="product-name" >{{ data.nombre }}</div>
                                        </div>
                                      </dx-select-box>
                                  </div>
                                    </dx-data-grid>
                            </div>
                </div>
            </section>
        </div>
    </div>
</div>
